var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"members column vertical"},_vm._l((_vm.members),function(member,mi){return _c('li',{key:['member-item', mi].join('-')},[_c('member-view',{attrs:{"member":member}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }